/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { memo, useCallback } from 'react';

import cn from 'classnames';
import PropTypes from 'prop-types';

import Icon from '../../../Icon';
import SkeletonItem from '../../../dropdown/view/SkeletonItem';
import s from './CategoryDropdownItem.module.scss';
import localization from '../../../../shared/strings';

const CategoryDropdownItem = ({
  item, checked, highlighted, toggleCheck, style,
}) => {
  const handleClick = useCallback((e) => {
    e.stopPropagation();
    e.preventDefault();
    return toggleCheck(item);
  }, [toggleCheck, item]);

  const showTrailing = Boolean(item.parentPathLabel || item.showChevron);

  if (item.isSkeleton) {
    return (
      <div style={style}>
        <SkeletonItem />
      </div>
    );
  }

  return (
    <div
      className={cn('dropdown-item', s.item, { active: checked, highlighted })}
      style={style}
      data-testid={`dropdown-item-${item.title}`}
      onClick={handleClick}
      onDoubleClick={handleClick}
    >
      <Icon name="ok" />
      <div className={cn('dropdown-item-text', s.content)}>
        <div className={s.leading}>
          <If condition={item.isBack}>
            <Icon name="regularPrevArrow" className={s.leadingIcon} />
          </If>
          <If condition={item.title}>
            <div className={cn('dropdown-item-title', s.title)}>{item.title}</div>
          </If>
        </div>
        <If condition={showTrailing}>
          <div className={s.trailing}>
            <If condition={item.parentPathLabel}>
              <div className={cn('dropdown-item-descr', s.parentPath)}>{item.parentPathLabel}</div>
            </If>
            <If condition={item.showChevron}>
              <Icon name="regularNextArrow" className={s.chevron} />
            </If>
          </div>
        </If>
      </div>
    </div>
  );
};

CategoryDropdownItem.defaultProps = {
  style: {},
};

CategoryDropdownItem.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    isBack: PropTypes.bool,
    isSkeleton: PropTypes.bool,
    showChevron: PropTypes.bool,
    parentPathLabel: PropTypes.string,
  }).isRequired,
  toggleCheck: PropTypes.func.isRequired,
  highlighted: PropTypes.bool.isRequired,
  checked: PropTypes.bool.isRequired,
  style: PropTypes.any,
};

export default memo(CategoryDropdownItem);
